import { render, staticRenderFns } from "./MyDetail.vue?vue&type=template&id=d06a010a&scoped=true&"
import script from "./MyDetail.vue?vue&type=script&lang=js&"
export * from "./MyDetail.vue?vue&type=script&lang=js&"
import style0 from "./MyDetail.vue?vue&type=style&index=0&id=d06a010a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d06a010a",
  null
  
)

export default component.exports